import * as React from 'react';
import { Link } from '@material-ui/core';
import { LoginEnum } from 'src/constants/Enum/LoginEnum';
import SuccessEmailLogo from './../../../assets/images/SuccessEmail.jpg'

export default class ResetPasswordComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.handleGotoLogin = this.handleGotoLogin.bind(this);

    }

    handleGotoLogin = () => {
        this.props.handleComponentRendering(LoginEnum.Login);
    }
    render() {
        return (
            <>
                <div className="loginTitleSection">
                    {/* <Typography component="h4" variant="title" align="center" gutterBottom={true} className="registerTitle">
                        Reset Password
                    </Typography> */}
                </div>

                <div className="loginContentSection">

                    <div className="alignCenter">
                        <img src={SuccessEmailLogo} alt="Success Email Logo"/>
                    </div>

                    <div className="loginContentSection">
                        <div className="loginText-l">
                            <span>We have successfully sent the reset password link on the Unicef's registered e-mail id. </span>                         
                            <span>You can now sign in and reset password from there.</span>
                        </div>
                    </div>

                    <Link className="loginGoToLink" href="javascript:void(0)" onClick={this.handleGotoLogin}>Go to Login</Link>

                </div>


            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/login/forgotPassword/ForgotPasswordEmailLinkComponent.tsx